import cn from 'classnames';
import type { ReactNode } from 'react';
import { ListBody } from '@shared/ui/index.ts';
import * as st from './styles.module.scss';

type PT = {
  isFilterOpen: boolean;
  isShowBlank: boolean;
  Filter: ReactNode;
  List: ReactNode;
  EmptyBlank: ReactNode;
};
export const BodyWithFilterAndList = ({
  Filter,
  List,
  EmptyBlank,
  isShowBlank,
  isFilterOpen,
}: PT) => {
  return (
    <ListBody className={cn(st.body, isFilterOpen ? st.filterOpened : st.filterClosed)}>
      <section className={cn(st.filter, isFilterOpen ? st.filterOpened : st.filterClosed)}>
        {Filter}
      </section>
      <section className={cn(st.list, isFilterOpen ? st.filterOpened : st.filterClosed)}>
        {isShowBlank ? EmptyBlank : List}
      </section>
    </ListBody>
  );
};
